/*
 * @Descripttion: 调用印度邮编查询城市接口
 * @Author: cmall
 * @Date: 2026-08-15
 */
import axios from 'axios'

// 根据邮编查询城市
const lookupPincode = pincode =>
  axios.get('/api/v1/pincode/lookup', { params: { pincode } }).then(res => res.data)

export default { lookupPincode }
